import {isAxiosError} from "axios";
import {notificationStore} from "~/stores/init";

const UNDO_MS = 8000;

// One notice at a time, each under a new id: reusing an id keeps the old auto-hide timer and Undo action.
let toastSeq = 0;
let currentToast: string | null = null;

function notify(message: string, options: Parameters<typeof notificationStore.show>[1]) {
    if (currentToast) notificationStore.hide(currentToast);
    currentToast = `category-record-${toastSeq++}`;
    notificationStore.show(message, {...options, id: currentToast});
}

/** The server's reason (`detail`, or the first field error), else a generic message. */
export function errorText(e: unknown): string {
    if (isAxiosError(e)) {
        const data = e.response?.data as Record<string, unknown> | undefined;
        if (typeof data?.detail === 'string') return data.detail;
        const first = data && Object.values(data)[0];
        if (Array.isArray(first) && typeof first[0] === 'string') return first[0];
        if (e.response?.status === 403) return 'You can view this category but not change it.';
    }
    return 'Could not save the change. Please try again.';
}

export function failed(e: unknown) {
    notify(errorText(e), {severity: 'error', autoHideDuration: 6000});
}

/** A 4s notice, or an 8s one with Undo (spec 2: every destructive or bulk change offers Undo). */
export function done(message: string, undo?: () => Promise<unknown>) {
    notify(message, {
        severity: 'success',
        autoHideDuration: undo ? UNDO_MS : 4000,
        ...(undo && {
            actionText: 'Undo',
            onAction: () => {
                undo().then(() => done('Change undone.')).catch(failed);
            },
        }),
    });
}

